<div class="auth-modal">
  <p class="text auth-modal__text">Авторизацию проходят только корпоративные аккаунты</p>

  <form class="form" tuiForm>
    <label tuiLabel tuiAppearance="ai-label">
      <span class="ai-label">Email</span>
      <tui-textfield class="form__textfield">
        <input
          [formControl]="email"
          type="email"
          tuiAutoFocus
          tuiTextfield
          placeholder="Введите email"
        />
      </tui-textfield>

      @if (email.touched) {
        @if (email.hasError('required')) {
          <tui-error error="Email не может быть пустым"></tui-error>
        }
        @if (email.hasError('maxlength')) {
          <tui-error error="Имя пользователя не должно превышать 255 символов"> </tui-error>
        }
        @if (email.hasError('email')) {
          <tui-error error="Неверный email"> </tui-error>
        }
      }
    </label>

    <footer>
      <button
        class="button"
        [loading]="authModalStore.isLoading()"
        [disabled]="!email.valid"
        (click)="login()"
        type="button"
        tuiButton
        appearance="ai-primary"
        size="m"
      >
        Авторизоваться
      </button>
    </footer>
  </form>
</div>
